import React from "react";
import { Button, Col, Row } from "antd";
import { i18, trb } from "@utilities";

export const MissingDocumentItem = React.memo(
  ({ reviewerComment, documentName, documentType, fileCommentFlags, handleDocDelete }) => {
    return (
      <Row className="mt-2">
        <Col span={4}>
          <div>{documentName}</div>
        </Col>
        <Col span={5} offset={1}>
          <div>{reviewerComment}</div>
        </Col>
        <Col span={4} offset={1}>
          <div>{documentType}</div>
        </Col>
        <Col span={5} offset={1}>
          <div>{fileCommentFlags}</div>
        </Col>
        <Col span={2} offset={1}>
          <Button onClick={() => handleDocDelete(documentName)} danger>
            {`${trb(i18.Buttons.Delete)}`}
          </Button>
        </Col>
      </Row>
    );
  }
);
